export const SET_PROGRESS_NOTES = 'PNGlobalContext.SET_PROGRESS_NOTES';
export const SET_ORDER_TYPES = 'PNGlobalContext.SET_ORDER_TYPES';
export const SET_PATIENT_APPROVALS = 'PNGlobalContext.SET_PATIENT_APPROVALS';
export const SET_PATIENT_ORDERS = 'PNGlobalContext.SET_PATIENT_ORDERS';
export const SET_NOTES_READY = 'PNGlobalContext.SET_NOTES_READY';
export const REFRESH_PN_GLOBAL_CONTEXT = 'PNGlobalContext.REFRESH_PN_GLOBAL_CONTEXT';
export const REFRESH_PN_DATA = 'PNGlobalContext.REFRESH_PN_DATA';
export const RESET_REFRESH_PN_DATA = 'PNGlobalContext.RESET_REFRESH_PN_DATA';
export const SET_NEXT_IDG_MEETING = 'PNGlobalContext.SET_NEXT_IDG_MEETING';
export const SET_PATIENT_ON_AD_HOC_IDG_AGENDA = 'PNGlobalContext.SET_PATIENT_ON_AD_HOC_IDG_AGENDA';
export const SET_IDG_FILTER = 'PNGlobalContext.SET_IDG_FILTER';
/** One-shot: next unfiltered PN load should fetch full list (IDG switch → All notes). */

export const SET_REFETCH_ALL_PROGRESS_NOTES_PENDING = 'PNGlobalContext.SET_REFETCH_ALL_PROGRESS_NOTES_PENDING';